<app-nav></app-nav>

<div class="SdF--principal">
	<router-outlet></router-outlet>
</div>
